import { computed } from 'vue'
import { useBreakpoints } from '@vueuse/core'

export function useBreakpoint() {
  const breakpointsMap = {
    smallMobile: 'smallMobile',
    mobile: 'mobile',
    tablet: 'tablet',
    smallTablet: 'smallTablet',
    midTablet: 'midTablet',
    smallLaptop: 'smallLaptop',
    midLaptop: 'midLaptop',
    laptop: 'laptop',
    widescreen: 'widescreen',
    ultrawide: 'ultrawide',
  }

  const breakpointsValues = {
    [breakpointsMap.smallMobile]: 375,
    [breakpointsMap.mobile]: 490,
    [breakpointsMap.smallTablet]: 570,
    [breakpointsMap.midTablet]: 744,
    [breakpointsMap.tablet]: 834,
    [breakpointsMap.smallLaptop]: 1024,
    [breakpointsMap.midLaptop]: 1280,
    [breakpointsMap.laptop]: 1440,
    [breakpointsMap.widescreen]: 2600,
    [breakpointsMap.ultrawide]: 2600,
  }

  const breakpoints = useBreakpoints({
    [breakpointsMap.smallMobile]: breakpointsValues[breakpointsMap.smallMobile],
    [breakpointsMap.mobile]: breakpointsValues[breakpointsMap.mobile],
    [breakpointsMap.smallTablet]: breakpointsValues[breakpointsMap.smallTablet],
    [breakpointsMap.midTablet]: breakpointsValues[breakpointsMap.midTablet],
    [breakpointsMap.tablet]: breakpointsValues[breakpointsMap.tablet],
    [breakpointsMap.smallLaptop]: breakpointsValues[breakpointsMap.smallLaptop],
    [breakpointsMap.midLaptop]: breakpointsValues[breakpointsMap.midLaptop],
    [breakpointsMap.laptop]: breakpointsValues[breakpointsMap.laptop],
    [breakpointsMap.widescreen]: breakpointsValues[breakpointsMap.widescreen],
    [breakpointsMap.ultrawide]: breakpointsValues[breakpointsMap.ultrawide],
  })

  const isUnderSmallLaptop = computed(() => {
    return breakpoints.smaller(breakpointsMap.smallLaptop).value
  })

  const isUnderLaptop = computed(() => {
    return breakpoints.smaller(breakpointsMap.laptop).value
  })

  return {
    breakpointsMap,
    breakpointsValues,
    breakpoints,
    isUnderSmallLaptop,
    isUnderLaptop,
    isSmallMobile: breakpoints.smaller(breakpointsMap.smallMobile),
    isMobile: breakpoints.smaller(breakpointsMap.mobile),
    isSmallTablet: breakpoints.smaller(breakpointsMap.smallTablet),
    isTablet: breakpoints.smaller(breakpointsMap.tablet),
    isUnderMidTablet: breakpoints.smaller(breakpointsMap.midTablet),
    isUnderTablet: breakpoints.smaller(breakpointsMap.tablet),
    isSmallLaptop: breakpoints.between(breakpointsMap.tablet, breakpointsMap.smallLaptop),
    isLaptop: breakpoints.between(breakpointsMap.smallLaptop, breakpointsMap.laptop),
    isWidescreen: breakpoints.between(breakpointsMap.laptop, breakpointsMap.widescreen),
    isUltrawide: breakpoints.greater(breakpointsMap.ultrawide),
  }
}
